// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as ReactLeaflet from "react-leaflet";
import * as LeafletMapHelper from "../../../views/LeafletMapHelper.bs.js";

function getMapPadding(param) {
  return {
          top: 5,
          left: 5,
          bottom: 5,
          right: 5
        };
}

function LeafletHelper(Props) {
  var order_details = Props.order_details;
  var setMap = Props.setMap;
  var setBounds = Props.setBounds;
  var map = ReactLeaflet.useMap();
  var bounds = LeafletMapHelper.getBounds(order_details);
  React.useEffect((function () {
          map.fitBounds(bounds, {
                top: 5,
                left: 5,
                bottom: 5,
                right: 5
              });
          Curry._1(setMap, (function (param) {
                  return map;
                }));
          Curry._1(setBounds, (function (param) {
                  return bounds;
                }));
          
        }), [order_details]);
  return null;
}

var make = LeafletHelper;

export {
  getMapPadding ,
  make ,
  
}
/* react Not a pure module */
